/**
 * Maps a backend error_code from /api/loadData/* (W7 namespace) to a
 * frontend i18n key under firstProcessing.backendErrors.*.
 *
 * Mirrors W6 backendErrorMapper pattern. Contract: BE returns
 * { error, error_code, suggestions } from W7 killshot fix.
 *
 * Returns null translationKey for unknown codes. Caller falls back to
 * `suggestion` (preferred — it's localized by BE) or `message` (English).
 */

export const KNOWN_FIRST_PROCESSING_ERROR_CODES = [
  // Inherited from LoadDataException (shared with W6)
  'VALIDATION_ERROR',
  'MISSING_PARAMETER',
  'INVALID_PARAMETER',
  'DELIMITER_MISMATCH',
  'INVALID_COLUMN_INDEX',
  'PARSING_ERROR',
  'CSV_PARSING_ERROR',
  'DATETIME_PARSING_ERROR',
  'ENCODING_ERROR',
  'UPLOAD_ERROR',
  'CHUNK_UPLOAD_ERROR',
  'UPLOAD_NOT_FOUND',
  'INCOMPLETE_UPLOAD',
  'TIMEZONE_ERROR',
  'UNSUPPORTED_TIMEZONE',
  'TIMEZONE_CONVERSION_ERROR',
  'LOAD_DATA_ERROR',
] as const;

export type FirstProcessingErrorCode = (typeof KNOWN_FIRST_PROCESSING_ERROR_CODES)[number];

export interface FirstProcessingErrorInput {
  code: string | undefined;
  message: string | undefined;
  suggestion: string | undefined;
}

export interface FirstProcessingErrorMapping {
  translationKey: string | null;
  fallbackMessage: string;
}

const KNOWN_SET = new Set<string>(KNOWN_FIRST_PROCESSING_ERROR_CODES);

export function mapFirstProcessingBackendError(
  input: FirstProcessingErrorInput
): FirstProcessingErrorMapping {
  const fallback = input.suggestion ?? input.message ?? '';
  if (input.code && KNOWN_SET.has(input.code)) {
    return { translationKey: `backendErrors.${input.code}`, fallbackMessage: fallback };
  }
  return { translationKey: null, fallbackMessage: fallback };
}
